// Import model
import { PaymentTermsCondition } from '../models/PaymentTermsCondition';

// Import base class serializer

// Import dependency types (models and enums used in properties)
import { ApiPiConditionOperator } from '../models/ApiPiConditionOperator';
import { PaymentTermsIndexedFields } from '../models/PaymentTermsIndexedFields';

// Import dependency serializers (for complex types)
import { ApiPiConditionOperatorSerializer } from './ApiPiConditionOperatorSerializer';
import { PaymentTermsIndexedFieldsSerializer } from './PaymentTermsIndexedFieldsSerializer';

// Import derived type serializers (for polymorphic deserialization)

/**
 * Serializer for PaymentTermsCondition - handles JSON serialization and deserialization with type validation
 */
export class PaymentTermsConditionSerializer {
  /**
   * Deserializes a JSON string into a PaymentTermsCondition instance
   */
  static deserialize(json: string): PaymentTermsCondition {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a PaymentTermsCondition instance
   */
  static fromObject(obj: any): PaymentTermsCondition {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to PaymentTermsCondition');
    }


    const instance: PaymentTermsCondition = {
      fieldName: obj['fieldName'] as PaymentTermsIndexedFields | undefined,
      operator: obj['operator'] as ApiPiConditionOperator | undefined,
      value: obj['value'] as any | undefined,
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of PaymentTermsCondition instances
   */
  static deserializeArray(json: string): PaymentTermsCondition[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a PaymentTermsCondition instance to a JSON string
   */
  static serialize(instance: PaymentTermsCondition): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a PaymentTermsCondition instance to a plain object
   */
  static toObject(instance: PaymentTermsCondition): any {
    return {
      'fieldName': instance.fieldName,
      'operator': instance.operator,
      'value': instance.value,
    };
  }

  /**
   * Serializes an array of PaymentTermsCondition instances to a JSON string
   */
  static serializeArray(instances: PaymentTermsCondition[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
